import { BasicContainer } from '@/components/Common/BasicContainer/BasicContainer';
import FormItem from '@/components/Common/FormItem/FormItem';
import { FormSectionTitle } from '@/components/Form/FormSectionTitle/FormSectionTitle';
import { Button, Grid, OutlinedInput, Stack } from '@mui/material';
import { useSellerBusinessDataViewController } from './SellerBusinessDataViewController';

export function SellerBusinessData() {
  const { uiState, actions } = useSellerBusinessDataViewController();

  return (
    <Stack spacing={'12px'} p={{ xs: '16px', md: '0px' }}>
      <FormSectionTitle title={'Datos del Negocio'} />
      <BasicContainer
        content={
          <Grid container columnSpacing={'20px'} p={'16px'}>
            <Grid size={12}>
              <FormItem
                label="Nombre de tu negocio"
                helperText={uiState.businessNameError}
              >
                <OutlinedInput
                  fullWidth
                  value={uiState.businessName}
                  onChange={(e) =>
                    actions.onBusinessNameChanged(e.target.value)
                  }
                  error={!!uiState.businessNameError}
                />
              </FormItem>
            </Grid>
          </Grid>
        }
        footer={
          <Stack sx={{ flexDirection: 'row-reverse', p: '16px' }} gap={'16px'}>
            <Button
              variant="contained"
              disabled={uiState.saveDisabled}
              onClick={actions.onClickedSave}
            >
              Guardar cambios
            </Button>
            <Button
              variant="outlined"
              disabled={uiState.cancelDisabled}
              onClick={actions.onClickedCancel}
            >
              Cancelar
            </Button>
          </Stack>
        }
      />
    </Stack>
  );
}
